import { render, staticRenderFns } from "./FlyerThumbList.vue?vue&type=template&id=366c81a2&scoped=true"
import script from "./FlyerThumbList.vue?vue&type=script&lang=js"
export * from "./FlyerThumbList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366c81a2",
  null
  
)

export default component.exports